export class InvalidServiceAccountTokenError extends Error {
    constructor() {
        super('Invalid service account token specified');
    }
}
export const parseServiceAccountToken = (input) => {
    if (!input) {
        throw new InvalidServiceAccountTokenError();
    }
    const [prefix, webServiceToken, secretKey, ...rest] = input.split(':');
    if (!prefix || !webServiceToken || !secretKey || rest.length > 0) {
        throw new InvalidServiceAccountTokenError();
    }
    return { prefix, webServiceToken, secretKey };
};
export const getServiceAccountWebServiceToken = (token) => `${token.prefix}:${token.webServiceToken}`;
